<script setup lang="ts">
import { useRoute }  from '#imports'
import { computed } from 'vue'
import { useAppColor } from '~/composables/useAppColor'
import useAppBanner from '~/composables/banner'
import AuLogoSimple from '~/components/utils/AuLogoSimple.vue'

const { themeColor } = useAppColor()
const route = useRoute()
const { headerColor } = useAppBanner()

const textColor = computed(() => {
  const name = themeColor.value || ''
  const matches = /-(?:5|10|20)(?=\)?$)/.test(name)
  return (matches || route.name === 'search') ? 'text-black' : 'text-white'
})
</script>

<template>
  <AuLogoSimple
    class="h-8"
    :class="headerColor ? 'text-white' : textColor"
  />
</template>
